import { useState } from "react";
import useAxiosInstance from "../../hooks/useAxiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { API_RESULT, API_VERSION } from "../../enums/common.enum";
import {
  errorToast,
  handleError,
  successToast,
  transformAllSupplierPurchases,
} from "../../utils/common";
import { setAllSupplierPurchase } from "../../store/actions/useActions";
import { Form, Formik } from "formik";
import { Box, CircularProgress, Grid, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const BankPayment = ({ purchaseData, lat, long, setPaymentModal }: any) => {
  const [loading, setLoading] = useState(false);
  const privateInstance = useAxiosInstance();
  const dispatch = useDispatch();
  let invoiceToManage = useSelector(
    (state: any) => state.supplier.allPurchaseData
  );

  const handleSubmit = async (values: any, actions: any) => {
    let payload = {
      order_id: purchaseData?.purchase_id,
      payment_partner: "supplier",
      payment_type: "INSTANT",
      provider_id: purchaseData?.location_id,
      location_id: purchaseData?.location_id,
      amount: values.payable_amount.toString(),
      discount_pct: "0.0",
      location: `${lat},${long}`,
      notes: "",
      other_charges: "0",
    };

    try {
      const result = await privateInstance.post(
        `${API_VERSION.V1}/orders/payments/transfer`,
        payload
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        successToast("Payment initiated");
        setPaymentModal(false);
        //update
        dispatch(
          setAllSupplierPurchase(
            transformAllSupplierPurchases(
              invoiceToManage,
              purchaseData.purchase_id,
              result.data.response
            )
          )
        );
      } else {
        errorToast(result.data.message);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          bank: purchaseData?.beneficiary_details.bank || "",
          account_name: purchaseData?.beneficiary_details.account_name || "",
          account_no: purchaseData?.beneficiary_details.account_no || "",
          ifsc_code: purchaseData?.beneficiary_details.ifsc_code || "",
          invoice_amount: purchaseData?.invoice_amount || 0,
          payable_amount: purchaseData?.payable_amount || 0,
        }}
        onSubmit={(values: any, actions: any) => {
          setLoading(true);
          actions.setSubmitting(false);
          handleSubmit(values, actions);
        }}
      >
        {(props: any) => {
          const {
            values,
            touched,
            errors,
            handleBlur,
            isSubmitting,
            setFieldValue,
          } = props;
          return (
            <Form>
              <Grid container spacing={2} sx={{ mt: 2.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="bank"
                    label="BANK NAME"
                    size="small"
                    value={values.bank}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="account_name"
                    label="ACCOUNT NAME"
                    size="small"
                    value={values.account_name}
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="account_no"
                    label="ACCOUNT NUMBER"
                    size="small"
                    value={values.account_no}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="ifsc_code"
                    label="IFSC CODE"
                    size="small"
                    value={values.ifsc_code}
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="invoice_amount"
                    label="INVOICE AMOUNT"
                    size="small"
                    value={values.invoice_amount}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="payable_amount"
                    label="PAYABLE AMOUNT"
                    size="small"
                    value={values.payable_amount}
                    disabled
                  />
                </Grid>
              </Grid>
              <Box sx={{ mt: 5, textAlign: "center" }}>
                <LoadingButton
                  type="submit"
                  color="primary"
                  variant="contained"
                  loading={loading}
                  loadingIndicator={
                    <CircularProgress size={20} sx={{ color: "#fff" }} />
                  }
                  disabled={isSubmitting}
                >
                  Confirm payment
                </LoadingButton>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default BankPayment;
